import { render, staticRenderFns } from "./IndividualTableCount.vue?vue&type=template&id=b9d3fbc2"
import script from "./IndividualTableCount.vue?vue&type=script&lang=js"
export * from "./IndividualTableCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports